import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { useTrans, useTealium } from '@next-nx/hooks'
import { WImage, Button } from '@next-nx/shared-ui/atoms'
import { getTimestamp } from '@next-nx/utils';
import styles from './NoleggioStepOffertaAnimation.module.sass'


interface Props {
  item: MenuItemType
  className?: string
}

const NoleggioStepOffertaAnimation = (props: Props) => {

  const { 
    item = undefined,
    className = '',
  } = props

  const t = useTrans()
  const { linkDataLayer } = useTealium()

  const handleTracking = () => {
    const action_timestamp = getTimestamp()

    linkDataLayer({
      virtual: 'action',
      action_name: 'richiesta_preventivo',
      action_tech: 'click',
      action_type: 'richiedi_preventivo',
      action_timestamp,
      action_effect: 'form_richiesta_preventivo_accesso',
    })
  }

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.content}>
        <div className={styles.item}>
          <div className={styles.itemTitle}>{t("Durata noleggio")}</div>
          <div className={styles.itemValue}>{t("60 mesi")}</div>
        </div>
        <div className={`${styles.item} ${styles['item--animation']}`}>
          <div className={styles.itemTitle}>{t("Chilometraggio")}</div>
          <div className={styles.itemValue}>
            <span>{t("10.000 km / anno")}</span>
            <span>{t("15.000 km / anno")}</span>
            <span>{t("20.000 km / anno")}</span>
          </div>
        </div>
        <div className={styles.ctaBox}>
          <div className={styles.cta}>
            {t("Richiedi preventivo")}
          </div>
        </div>
      </div>
      <div className={styles.imageBox}>
        <WImage
          src={item.image}
          alt={item.name}
          title={item.name}
          maxWidth={292}
          maxHeight={203}
        />
      </div>
    </div>
  ) : <></>
}

export default NoleggioStepOffertaAnimation
